import React from 'react';

const Edit = (props) => {
    const handleEditClick = () => {
        props.openEditModal(props.data);
    };

    return (
        <div onClick={handleEditClick} title="Edit">
            <i className="fa fa-edit"></i> Edit
        </div>

    );
};

export default Edit;